import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: max-content;
  width: 424px;
  padding: 16px;
`;

export const ContainerChild = styled.div``;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export const TextContainer = styled.div`
  margin-top: 4px;
`;

export const TextParagraph = styled.p`
  font-size: 12px;
  text-align: center;
  font-family: "sans-serif";
  line-height: 16px;
  font-weight: 500;
`;

export const RetryButton = styled.button`
  display: block;
  margin: 10px auto 0;
  padding: 6px 16px;
  border: 1px solid #9b5af8;
  border-radius: 6px;
  background: #ffffff;
  color: #6f27d6;
  font: 600 12px "DM Sans", sans-serif;
  cursor: pointer;

  &:hover {
    background: #efe9fe;
  }
`;
